<script lang="ts" setup>
defineEmits(['click']);
const props = defineProps({
  url: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  topIcon: {
    type: String,
    default: '',
  },
  counterBadge: {
    type: Number,
    default: 0,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
});

function checkCurrentRoute() {
  const route = useRoute();

  if (route.path === props.url) {
    window.scrollTo(0, 0);
  }
}
</script>

<template>
  <AppLink
    :class="{ 'menu-action-btn--active': isActive }"
    :to="url"
    class="menu-action-btn"
    @click="checkCurrentRoute"
  >
    <component
      :is="`Svgo${topIcon}`"
      v-if="topIcon"
      class="menu-action-btn__icon"
      filled
    />

    {{ label }}

    <span
      v-show="counterBadge"
      class="menu-action-btn__counter-badge"
    >
      {{ counterBadge }}
    </span>
  </AppLink>
</template>

<style lang="scss" scoped>
.menu-action-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  width: 65px;
  padding: 0.25rem;
  border-radius: 8px;
  font-size: $text-2xs;
  transition: all 0.2s;

  &:hover {
    background-color: $hell-black-5;
    color: $hell-black;
  }

  &__icon {
    width: 25px;
    height: 25px;
  }

  &__counter-badge {
    position: absolute;
    top: -3px;
    right: -3px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background-color: $hell-green;
    color: $white;
    font-weight: $bold;
    font-size: $text-xs;
  }

  &--active {
    background-color: $hell-black;
    color: $white;
    stroke: $white;
  }
}
</style>
